import React from 'react';
import { DefaultIconProps } from '@gamiphy/icons/types';

const Person: React.FC<DefaultIconProps> = ({
  color,
  width,
  height,
}) => (
  <svg width={width ?? 16} height={height ?? 20} viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8.00018 0.899994C5.48728 0.899994 3.45018 2.9371 3.45018 5.44999C3.45018 7.96289 5.48728 9.99999 8.00018 9.99999C10.5131 9.99999 12.5502 7.96289 12.5502 5.44999C12.5502 2.9371 10.5131 0.899994 8.00018 0.899994ZM5.40018 5.44999C5.40018 4.01405 6.56424 2.84999 8.00018 2.84999C9.43612 2.84999 10.6002 4.01405 10.6002 5.44999C10.6002 6.88593 9.43612 8.04999 8.00018 8.04999C6.56424 8.04999 5.40018 6.88593 5.40018 5.44999Z" fill={color} />
    <path fillRule="evenodd" clipRule="evenodd" d="M15.1293 15.4948C13.6909 12.9057 10.962 11.3 8.00016 11.3C5.03837 11.3 2.30939 12.9057 0.871018 15.4948L0.303362 16.5166C-0.340549 17.6756 0.497551 19.1 1.82345 19.1H14.1769C15.5028 19.1 16.3409 17.6756 15.697 16.5166L15.1293 15.4948ZM2.57562 16.4418C3.67008 14.4718 5.74655 13.25 8.00016 13.25C10.2538 13.25 12.3302 14.4718 13.4247 16.4418L13.8181 17.15H2.18219L2.57562 16.4418Z" fill={color} />
  </svg>
);
export default Person;
